<template>
  <div
    class="map-block p-relative overflow-hidden container"
    :style="{
      padding: blockPadding,
      height: height,
      minHeight: height,
      minHeight: `calc(${height} + env(safe-area-inset-top))`
    }"
  >
    <location-map
      ref="location-map"
      :lat="map.lat"
      :lng="map.lng"
      :height="height"
      :interactive="!isBuilderContext()"
    />
  </div>
</template>

<script>
import { BLOCK_DEFAULT_HEIGHT_RATIO } from "@/lib/stream-utils"
import { withRatio, toPadding, BLOCK_BASE_HEIGHT } from "@shared/block-ratio"
import { isBuilderContext } from "@/lib/utils"

export default {
  components: {
    LocationMap: () => import("@/components/LocationMap")
  },

  props: {
    map: { type: Object, require: true },
    spaceXRatio: { type: Number, default: 0 },
    spaceTopRatio: { type: Number, default: 0 },
    spaceBottomRatio: { type: Number, default: 0 },
    heightRatio: { type: Number, default: BLOCK_DEFAULT_HEIGHT_RATIO }
  },

  computed: {
    blockPadding() {
      return toPadding(
        this.spaceTopRatio,
        this.spaceXRatio,
        this.spaceBottomRatio
      )
    },

    height() {
      return withRatio(BLOCK_BASE_HEIGHT, this.heightRatio)
    }
  },

  mounted() {
    this.$watch(
      vm => [vm.height, vm.blockPadding],
      () => {
        this.$refs["location-map"].resizeMap()
      },
      { deep: true }
    )
  },

  methods: {
    isBuilderContext
  }
}
</script>
